export const embarrassingPhrases = [
  "Eu nunca faltei ao trabalho por beber demasiado na noite anterior.",
  "Eu nunca tive uma experiência paranormal.",
  "Eu nunca fiquei com um estranho.",
  "Eu nunca usei drogas.",
  "Eu nunca olhei o celular de alguém sem permissão.",
  "Eu nunca disse que prestava.",
  "Eu nunca traí você.",
  "Eu nunca olhei o armário do banheiro de um amigo.",
  "Eu nunca fiz ou recebi uma lap dance.",
  "Eu nunca enviei uma mensagem picante para a pessoa errada.",
  "Eu nunca fui algemado (por qualquer motivo).",
  "Eu nunca cheirei minha roupa interior para saber se está limpa ou não.",
  "Eu nunca trabalhei alcoolizado.",
  "Eu nunca fiquei com um ex do meu melhor amigo.",
  "Eu nunca deletei um post em uma rede social por ter poucas curtidas.",
  "Eu nunca roubei um objeto de uma loja.",
  "Eu nunca engravidei.",
  "Eu nunca tive de correr para me salvar.",
  "Eu nunca quebrei algo em casa de amigo e não contei para ele.",
  "Eu nunca fiz fotos pelado.",
  "Eu nunca levei algo ilegal na fronteira.",
  "Eu nunca fui algemado.",
  "Eu nunca entrei em uma festa sem ser convidado.",
  "Eu nunca dei um tapa na cara.",
  "Eu nunca tomei um tapa na cara em público.",
  "Eu nunca saí na porrada.",
  "Eu nunca fiquei com alguém por interesse.",
  "Eu nunca achei que eu sou a pessoa mais bonita dessa roda.",
  "Eu nunca duvidei da minha sexualidade.",
  "Eu nunca vi alguém dançando e me excitei.",
  "Eu nunca fiquei beijando meu melhor amigo.",
  "Eu nunca fiquei preocupado pensando que teria um filho.",
  "Eu nunca fiz um procedimento estético e disse que era tudo natural.",
  "Eu nunca coloquei enchimento no sutiã / na calcinha.",
  "Eu nunca coloquei enchimento na sunga.",
  "Eu nunca viajei com drogas.",
  "Eu nunca tive uma bad trip.",
  "Eu nunca fiz simpatia para ter meu ex de volta/para conquistar alguém/para me vingar...",
  "Eu nunca joguei água/comida em alguém.",
  "Eu nunca lambi uma ferida.",
  "Eu nunca vi alguém morto.",
  "Eu nunca provei leite materno depois de adulto.",
  "Eu nunca vi uma arma.",
  "Eu nunca fiz uma tatuagem ridícula.",
  "Eu nunca coloquei fogo em alguma coisa.",
  "Eu nunca disse 'te amo' sem querer",
  "Eu nunca cheirei minhas roupas íntimas para saber se estavam sujas.",
  "Eu nunca fiquei com o ex de um amigo.",
  "Eu nunca tentei atrasar a menstruação.",
  "Eu nunca pensei que tivesse uma doença grave.",
  "Eu nunca escondi um segredo da minha família.",
  "Eu nunca fiz um teste de gravidez.",
  "Eu nunca fumei maconha.",
  "Eu nunca fiz uma declaração em público.",
  "Eu nunca descobri que um amigo estava sendo traído.",
  "Eu nunca desisti de uma amizade.",
  "Eu nunca enviei uma mensagem pesadona para o número errado.",
  "Eu nunca fui corrupto.",
  "Eu nunca tomei pílula do dia seguinte.",
  "Eu nunca fiz uma dieta louca.",
  "Eu nunca fui para a delegacia.",
  "Eu nunca tive problemas com vizinhos.",
  "Eu nunca acordei na rua.",
  "Eu nunca usei aliança.",
  "Eu nunca perdi um presente importante.",
  "Eu nunca usei pomada vaginal/peniana.",
  "Eu nunca desapareci da vida de alguém.",
  "Eu nunca fiquei excitado em um momento inadequado.",
  "Eu nunca me gravei fazendo aquilo.",
  "Eu nunca transei menstruada.",
  "Eu nunca usei um ovo masturbador.",
  "Eu nunca tive vergonha dos meus próprios pensamentos.",
  "Eu nunca menti para meu chefe.",
  "Eu nunca fui corrupto.",
  "Eu nunca disse algo sem ter certeza do que estava falando.",
  "Eu nunca recebi flores sem saber de quem eram.",
  "Eu nunca fiquei preso dentro ou para fora de casa.",
  "Eu nunca soneguei impostos.",
  "Eu nunca convenci alguém a fazer algo errado.",
  "Eu nunca coloquei a culpa em outra pessoa.",
  "Eu nunca assisti a vídeos proibidos.",
  "Eu nunca invadi a privacidade de alguém.",
  "Eu nunca acusei alguém injustamente.",
  "Eu nunca falei mal de um amigo.",
  "Eu nunca tomei um chá alucinógeno.",
  "Eu nunca fui testemunha de um crime.",
  "Eu nunca levei um bolo de um crush.",
  "Eu nunca me vinguei de algo.",
  "Eu nunca senti rancor.",
  "Eu nunca sofri bullying.",
  "Eu nunca pratiquei bullying.",
  "Eu nunca acreditei na internet ao invés de ir ao médico.",
  "Eu nunca quebrei uma promessa.",
  "Eu nunca fiz greve de fome.",
  "Eu nunca tive uma intoxicação alimentar.",
  "Eu nunca fui a favor da legalização das armas.",
  "Eu nunca vendi meu voto.",
  "Eu nunca postei algo enquanto estava bêbado.",
  "Eu nunca vomitei dentro de um táxi.",
];
